/**
 * @generated SignedSource<<8f0cab1b76a6d4c6ec31ffe2569797c5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SpaceConfiguration = "BACE_CLATTERING_STANDARD" | "BACE_SATELLITE_LARGE_EXTENDED" | "BACE_SATELLITE_LARGE_STANDARD" | "BACE_SATELLITE_MEDIUM_EXTENDED" | "BACE_SATELLITE_MEDIUM_STANDARD" | "BACE_SATELLITE_SMALL_EXTENDED" | "BACE_SATELLITE_SMALL_SLIM" | "BACE_SATELLITE_SMALL_STANDARD" | "BACE_STOREFRONT_2XL" | "BACE_STOREFRONT_L" | "BACE_STOREFRONT_M" | "BACE_STOREFRONT_S" | "BACE_STOREFRONT_XL" | "BACE_TRUCK_HUB_STANDARD" | "THALIA_RENZ_STANDARD_M" | "THALIA_RENZ_STANDARD_S" | "THALIA_RENZ_STANDARD_XS" | "THALIA_RENZ_WIDE_M" | "THALIA_RENZ_WIDE_S" | "%future added value";
export type summary_spaceIdQuery$variables = {
  hubName: string;
};
export type summary_spaceIdQuery$data = {
  readonly hubMeta: {
    readonly city: string;
    readonly hub: {
      readonly availableConfigurations: ReadonlyArray<{
        readonly configuration: SpaceConfiguration;
        readonly spaces: ReadonlyArray<{
          readonly configuration: SpaceConfiguration;
          readonly frame: string;
          readonly id: string;
          readonly position: number;
        }>;
      }>;
      readonly id: string;
    };
    readonly id: string;
    readonly name: string;
    readonly postalCode: string;
    readonly street: string;
  };
};
export type summary_spaceIdQuery = {
  response: summary_spaceIdQuery$data;
  variables: summary_spaceIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AvailableSpaceConfiguration",
      "kind": "LinkedField",
      "name": "availableConfigurations",
      "plural": true,
      "selections": [
        (v7/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "spaces",
          "plural": true,
          "selections": [
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "frame",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "position",
              "storageKey": null
            },
            (v7/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v10 = {
  "enumValues": [
    "BACE_STOREFRONT_S",
    "BACE_STOREFRONT_M",
    "BACE_STOREFRONT_L",
    "BACE_STOREFRONT_XL",
    "BACE_STOREFRONT_2XL",
    "BACE_SATELLITE_SMALL_STANDARD",
    "BACE_SATELLITE_SMALL_SLIM",
    "BACE_SATELLITE_SMALL_EXTENDED",
    "BACE_SATELLITE_MEDIUM_STANDARD",
    "BACE_SATELLITE_MEDIUM_EXTENDED",
    "BACE_SATELLITE_LARGE_STANDARD",
    "BACE_SATELLITE_LARGE_EXTENDED",
    "BACE_CLATTERING_STANDARD",
    "BACE_TRUCK_HUB_STANDARD",
    "THALIA_RENZ_STANDARD_XS",
    "THALIA_RENZ_STANDARD_S",
    "THALIA_RENZ_STANDARD_M",
    "THALIA_RENZ_WIDE_S",
    "THALIA_RENZ_WIDE_M"
  ],
  "nullable": false,
  "plural": false,
  "type": "SpaceConfiguration"
},
v11 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "summary_spaceIdQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            (v4/*:: as any*/),
            (v5/*:: as any*/),
            (v6/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v8/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "summary_spaceIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "276f0eff3b53db1dc551676179119d2e",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "hubMeta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "hubMeta.city": (v9/*:: as any*/),
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.availableConfigurations": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "AvailableSpaceConfiguration"
        },
        "hubMeta.hub.availableConfigurations.configuration": (v10/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "Space"
        },
        "hubMeta.hub.availableConfigurations.spaces.configuration": (v10/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces.frame": (v9/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces.id": (v11/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces.position": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Int"
        },
        "hubMeta.hub.id": (v11/*:: as any*/),
        "hubMeta.id": (v11/*:: as any*/),
        "hubMeta.name": (v9/*:: as any*/),
        "hubMeta.postalCode": (v9/*:: as any*/),
        "hubMeta.street": (v9/*:: as any*/)
      }
    },
    "name": "summary_spaceIdQuery",
    "operationKind": "query",
    "text": "query summary_spaceIdQuery(\n  $hubName: String!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    street\n    city\n    postalCode\n    hub {\n      id\n      availableConfigurations {\n        configuration\n        spaces {\n          id\n          frame\n          position\n          configuration\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c04d3922b08439cd48d2abf315369f75";

export default node;
